import type { Job } from "@eai-toolkit/client";
import {
  type BaseQueryState,
  dehydrateQueryStateBase,
  dehydrateQueryStateToStringBase,
  hydrateQueryStateBase,
  hydrateQueryStateFromStringBase,
} from "@store/utils/queryStateUtils";
import type { Location } from "history";

import { DEFAULT_PAGE_LIMIT } from "@helpers/constants";

import {
  defaultSortField,
  getDefaultSortOrder,
} from "../../modules/jobs/data/fields";

// Jobs-specific QueryState type
export type JobQueryState = BaseQueryState<Job>;

const QUERY_DEFAULTS = {
  defaultSort: {
    fieldName: defaultSortField.fieldName,
    direction: getDefaultSortOrder(defaultSortField),
  },
  defaultLimit: DEFAULT_PAGE_LIMIT,
} as const;

export function dehydrateJobsQueryState(opts: {
  queryState: JobQueryState;
  location: Location;
}): URLSearchParams {
  return dehydrateQueryStateBase<Job>(opts);
}

export function hydrateJobsQueryState(location: Location): JobQueryState {
  return hydrateQueryStateBase<Job>(location, QUERY_DEFAULTS);
}

/**
 * Hydrates a serialized search string into a JobQueryState object.
 */
export function hydrateJobsQueryStateFromString(
  searchString: string,
): JobQueryState {
  return hydrateQueryStateFromStringBase<Job>(searchString, QUERY_DEFAULTS);
}

/**
 * Dehydrates a JobQueryState object to a serialized search string.
 */
export function dehydrateJobsQueryStateToString(
  queryState: JobQueryState,
): string {
  return dehydrateQueryStateToStringBase<Job>(queryState);
}
